/**
 * Percorsi degli asset di marca, in un unico posto.
 *
 * Questo modulo non importa nulla di proposito: viene usato anche dalla sidebar
 * e dalle pagine di login, e un import di `letterheadPdf.ts` (che carica jsPDF)
 * trascinerebbe la libreria PDF nel bundle d'ingresso.
 *
 * I nomi dei file sono minuscoli e senza spazi: gli spazi obbligano a
 * codificare l'indirizzo (%20) ed e' li' che le immagini si rompevano dentro
 * le email.
 */

/** Marchio su tela quadrata, per i punti in cui serve un formato quadro. */
export const BRAND_MARK = '/slab-marchio.png';

/** Logotipo esteso, per header larghi (email, intestazioni PDF). */
export const BRAND_WORDMARK = '/slab-logotipo.png';

/**
 * Logo del gestionale Pixel, mostrato in fondo al menu accanto al numero di
 * versione: l'app resta Pixel, e' l'azienda intestataria a cambiare.
 */
export const APP_LOGO = '/logo-pixel.png';

/** Icona dell'app (favicon, manifest, notifiche): e' il marchio del cliente. */
export const APP_ICON = '/slab-icon-512.png';
